import React, { useState } from 'react';
import api from '../api/api';
import ConfirmDialog from '../utils/ConfirmDialog';
import ButtonLoading from './ButtonLoading';
import { HelmetProvider } from 'react-helmet-async';

const PasswordReset = () => {
    const [email, setEmail] = useState('');  // メールアドレスを管理
    const [showModal, setShowModal] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');  // エラーメッセージを管理
    const [successMessage, setSuccessMessage] = useState('');  // 成功メッセージを管理
    const [showSuccessDialog, setShowSuccessDialog] = useState(false);
    const [isLoadding, setIsLoading] = useState(false);
    
    const handleOkClick = async () => {
        try {
            setShowModal(false);
            setIsLoading(true);
            const response = await api.post(`${process.env.REACT_APP_API_URL}/accounts/api/reset-password/`, {
                email: email,  // メールアドレスをリクエストに含める
            });
            setShowSuccessDialog(true);
            // setSuccessMessage('パスワードリセットリンクを送信しました。メールを確認し、リンクをクリックしてパスワードのリセットを行ってください。もしメールが届かない場合は、迷惑メールフォルダを確認するか、再度リセットを試みてください。');  // 成功メッセージを設定
            setErrorMessage('');  // エラーメッセージをクリア
        } catch (error) {
            if (error.response && error.response.data) {
                setErrorMessage('エラーが発生しました。メールアドレスを確認してください。');
            } else {
                setErrorMessage('サーバーエラーが発生しました。');
            }
            setSuccessMessage('');  // 成功メッセージをクリア
        } finally {
            setIsLoading(false);
        }
    };

    const handleCancelClick = () => {
        setShowModal(false);
    };

    const handleResetClick = async (e) => {
        e.preventDefault();
        if (email) {
            setShowModal(true);  // メールアドレスが有効なら確認ダイアログを表示
        } else {
            setErrorMessage('メールアドレスを入力してください。');
        }
    };

    return (
        <div className='background'>
            <div className="form-main">
                <h1>パスワードをリセットします</h1>
                <form method="post">
                    <input
                        type="email"
                        name="email"
                        placeholder="Mail Address"
                        className="form-control user-input"
                        maxLength="254"
                        required=""
                        id="id_email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}  // メールアドレスの変更を反映
                    />
                    <button className="btn" onClick={handleResetClick}>
                        {isLoadding ? <ButtonLoading /> : "リセットリンクを送信"}
                    </button>
                </form>

                {/* エラーメッセージの表示 */}
                {errorMessage && <p style={{ color: 'red' }}>{errorMessage}</p>}

                {/* 成功メッセージの表示 */}
                {showSuccessDialog && 
                    <>
                        <p>パスワードリセットリンクを送信しました。</p>
                        <p>メールを確認し、リンクをクリックしてパスワードのリセットを行ってください。</p>
                        <p>もしメールが届かない場合は、迷惑メールフォルダを確認するか、再度リセットを試みてください。</p>
                    </>
                }
                {/* 確認ダイアログの表示 */}
                {showModal && (
                    <ConfirmDialog
                        message={`パスワードをリセットしてもよいですか？`}
                        onOkClick={handleOkClick}
                        onCancelClick={handleCancelClick}
                    />
                )}
            </div>
        </div>
    );
};

export default PasswordReset;
